<template>
  <div class="eating-detail">
    <search placeholder="请输入食物名称" v-model="search.key" @search="handleSearch"></search>
    <div class="fui-article-page" v-html="content">
    </div>
  </div>
</template>

<script>
  import Search from './components/Search'
  import { getArticle } from './api/index.js'
  export default {
    name: 'eating-detail',
    components: {
      Search
    },
    data() {
      return {
        id: '',
        cid: '',
        search: {
          key: ''
        },
        content: ''
      }
    },
    created () {
      this.id = this.$route.query.id
      this.cid = this.$route.query.cid
      this.fetchData()
    },
    methods: {
      handleSearch(val) {
        this.$router.push({
          path: `/eating/list?search=${val}&id=${this.cid}`
        })
      },
      fetchData() {
        getArticle({id: this.id})
          .then(res => {
            this.content = res.data.data.content
          })
        .catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "./styles/index";
.eating-detail {
  overflow: hidden;

  /* 文章营销样式 */
  .article-index-page .fui-content,
  .article-list-page .fui-content {background: #f4f4f4;}

  .fui-article-page {background: #fff; padding: pxTOvw(20px);}

  .fui-article-page .fui-article-title {font-size: pxTOvw(48px);}
  .fui-article-page .fui-article-subtitle {height: auto; font-size: pxTOvw(32px); color: #8c8c8c; overflow: hidden;}
  .fui-article-page .fui-article-subtitle a {color: #607fa6;}
  .fui-article-page .fui-article-subtitle .nav {padding-top: pxTOvw(12px); float: left; font-size: pxTOvw(32px);}
  .fui-article-page .fui-article-subtitle .nav.right {float: right;}
  .fui-article-page .fui-article-subtitle .nav.padding {padding-left: pxTOvw(12px);}
  .fui-article-page .fui-article-content {padding-top: pxTOvw(8px);}
  .fui-article-page .fui-article-content .fui-article-notread {height: pxTOvw(32px); background: #F4F4F4; margin: pxTOvw(20px); padding-top: pxTOvw(100px); border: pxTOvw(4px) dashed #999; display: none;}
  .fui-article-page .fui-article-content .fui-article-notread p {line-height: pxTOvw(60px); text-align: center; font-size: pxTOvw(32px); color: #666;}
  .fui-article-page .fui-article-content .fui-article-gps {font-size: pxTOvw(32px); text-align: center; line-height: pxTOvw(80px); color: #666; padding-top: pxTOvw(80px); padding-bottom: pxTOvw(220px)}
  .fui-article-page .fui-article-content img {vertical-align:bottom; max-width: 100%; border: 0;}

  .article-index-page .fui-list-group {margin-top:pxTOvw(12px)}
  .article-index-page .fui-list-group .round {border-radius: pxTOvw(100px)}

  .article-index-page .fui-line .text {color: #999;}
  .article-index-page .fui-line.link:before {height: 0; border: 0;}
  .article-index-page .fui-line.link .text {color: #607fa6;}
  .article-index-page .fui-line:before {background: none; border-top: 1px dashed #999;}

  .article-index-page .swipe {height: auto; background: #f4f4f4;}
  .article-index-page .swipe .inner {background: #fff; padding:pxTOvw(20px); margin: 0 pxTOvw(20px); overflow: hidden; display: block;}
  .article-index-page .swipe img {width: 100%;}

  .article-report-page .fui-cell-title {color: #999;}
  .article-report-page .fui-cell-group {margin-top: 0;}
  .article-report-page .fui-cell-group .fui-cell.fui-cell-textarea .fui-cell-label {margin-top: pxTOvw(-192px)}
  .article-report-page .sub {display: block; margin-top: pxTOvw(80px);}

  .fui-article-list.template-0 .fui-list-media img,
  .fui-article-list.template-2 .fui-list-media img {height: pxTOvw(100px); width: pxTOvw(100px);}

  .fui-article-list.template-0 {background: #fff;}
  .fui-article-list.template-0 .topimg {height: auto; padding-bottom: pxTOvw(20px);}
  .fui-article-list.template-0 .topimg img {height: auto; width: 100%; display: block;}
  .fui-article-list.template-0 .fui-list-group {margin-top: 0;}

  .fui-article-list.template-1 a {color: #666;}
  .fui-article-list.template-1 .fui-card-list {padding-bottom: pxTOvw(16px);}

  .fui-article-list.template-2 .fui-tab-scroll .item.on {color: #0cc;}
  .fui-article-list.template-2 .fui-tab-scroll .item.on:before {background: #0cc;}

  .fui-tab-scroll {height: pxTOvw(80px); background: #fff; overflow-y: hidden; overflow-x: auto; white-space: normal; position: relative;}
  .fui-tab-scroll:after {content: ""; height: 1px; width: 100%; background: #efefef; position: absolute; left: 0; bottom: 0;}
  .fui-tab-scroll .container{z-index: -1;  height:pxTOvw(96px); overflow: auto;  white-space:nowrap;}
  .fui-tab-scroll .item {height:pxTOvw(80px); width:auto; overflow: hidden; line-height:pxTOvw(80px); text-decoration: none; color:#333; text-align: center; padding: pxTOvw(10px) pxTOvw(20px); font-size: pxTOvw(28px)}
  .fui-tab-scroll .item.on  {color:#ff6801; font-weight: bold; position: relative;}
  .fui-tab-scroll .item.on:before {content: ""; height: 2px; width: 100%; background: #ff6801; position: absolute; bottom: pxTOvw(-8px); left: 0;}

  .nbnc-list .fui-article-list.template-0 .fui-list-media img,
  .nbnc-list .fui-article-list.template-2 .fui-list-media img {
    height: pxTOvw(140px);
    width: pxTOvw(160px);
    border-radius: pxTOvw(12px)
  }

  .fui-list-inner .title {
    font-size: pxTOvw(30px);
    line-height: pxTOvw(40px);
    margin-bottom: pxTOvw(12px);
  }


  .tags-nbnc {
    padding: pxTOvw(12px) pxTOvw(8px)pxTOvw(24px) pxTOvw(8px);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .icon-nbnc {
    width: pxTOvw(38px);
    height: pxTOvw(38px);
    display: inline-block;
    background: transparent url('../../assets/eating/icon-0.png') no-repeat;
    background-size: cover;
    margin-right: 4px;
    position: relative;
    top: pxTOvw(8px);
  }

  div.tag-nbnc {
    display: flex;
    height: pxTOvw(48px);
    margin: pxTOvw(38px) 0 pxTOvw(15px);;
  }

  div.tag-nbnc strong {
    margin-right: pxTOvw(50px);;
  }

  div.tag-nbnc .icon-nbnc {
    padding-left: pxTOvw(44px);
    top: 0px;
    background-size: pxTOvw(38px);
    flex: 1;
    font-style: normal;
  }

  .tag-nbnc .icon-1 {
    background-image: url('../../assets/eating/icon-0.png');
    color: #FE0000;
  }
  .tag-nbnc .icon-2 {
    background-image: url('../../assets/eating/icon-1.png');
    color: #F3C811;
  }
  .tag-nbnc .icon-3 {
    background-image: url('../../assets/eating/icon-2.png');
    color: #79B729;
  }
  .custom-desc {
    height: 2.6em;
    overflow: hidden;
    color: #666;
    font-size: smaller;
  }

  .dcb-nav {
    margin: 20px 20px 0px 20px;
    text-align: center;
  }


  .nbnc-list .list-number {
    margin: 0 pxTOvw(30px) pxTOvw(16px) pxTOvw(30px);
    border-bottom: 1px solid #eee;
    position: relative;
  }

  .nbnc-list .fui-list {
    padding: pxTOvw(30px) 0;
  }

  .nbnc-list .fui-list-inner {
    overflow: initial;
  }

  .nbnc-list .fui-list-inner .text {
    width: pxTOvw(500px);
  }

  .dcb-list .list-number {
    padding: pxTOvw(26px) 0;
    margin: 0 pxTOvw(30px);
    border-top: 1px solid #eee;
    position: relative;
  }

  .dcb-list {
    padding-bottom: pxTOvw(88px);
  }

  .dcb-banner img {
    display: block;
    width: 100%;
    height: pxTOvw(88px);
    position: fixed;
    bottom: 0;
    border-top: 1px solid #eee;
  }



  .row-1 {
    padding-left: pxTOvw(60px);
    padding-bottom:pxTOvw(6px);
    font-size: pxTOvw(32px);
  }

  .row-2 {
    position: relative;
    height: pxTOvw(40px);
    min-height: pxTOvw(40px);
    overflow: hidden;
  }

  .open .row-2 {
    height: auto;
  }

  .row-2 .content {
    color: #868686;
    padding: 0 pxTOvw(40px) 0 pxTOvw(60px);
    font-size: pxTOvw(28px);
  }


  .fui-article-page {
    padding: pxTOvw(30px);
    font-size: pxTOvw(30px);
    line-height: pxTOvw(44px);
  }



}
</style>
